import {
  UsersUserIdInfoPatchRequest,
  UsersUserIdPersonalAccessTokensPostRequest,
  UsersUserIdPersonalAccessTokensTokenIdDeleteRequest,
} from '@nativewaves/nw-cloud-sdk/identity'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { userInfoQueryKey } from 'hooks/useUserInfo'
import { IdentityAPI } from 'services/api'
import { userQueryKeys } from 'services/queryKeys/identity'

/**
 * Edits a user's profile claims. Identity only lets a caller touch their own, so this is always the
 * signed-in user in practice — pass `'me'` as the id.
 *
 * Note how the API reads an omitted field: `null` means "leave what is there", so clearing a claim
 * takes an empty string rather than null.
 */
export const useUserInfoUpdateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: UsersUserIdInfoPatchRequest) => IdentityAPI.users.usersUserIdInfoPatch(params),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: userInfoQueryKey })
    },
  })
}

export const usePersonalAccessTokenCreateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: UsersUserIdPersonalAccessTokensPostRequest) =>
      IdentityAPI.users.usersUserIdPersonalAccessTokensPost(params),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: userQueryKeys.personalAccessTokenLists() })
    },
  })
}

export const usePersonalAccessTokenDeleteMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: UsersUserIdPersonalAccessTokensTokenIdDeleteRequest) =>
      IdentityAPI.users.usersUserIdPersonalAccessTokensTokenIdDelete(params),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: userQueryKeys.personalAccessTokenLists() })
    },
  })
}
